
import * as THREE from "three";

interface Props {
    color: string
    bgColor: string
}
const HomePlate = (props:Props) => {
    const shape = new THREE.Shape()
        .moveTo(0,0)
        .lineTo(8.5 / 12, 8.5 / 12)
        .lineTo(8.5 / 12, 17 / 12)
        .lineTo(-8.5 / 12, 17/12)
        .lineTo(-8.5/12, 8.5/12)
        .lineTo(0,0)

  return (
    <mesh position={[0,0,0]} rotation={[0,0,0]}>
        <shapeGeometry args={[shape]} />
        <meshBasicMaterial color={props.color} />
    </mesh>
  )
}

export default HomePlate